/* eslint-disable sort-imports */
/* eslint-disable perfectionist/sort-objects */
/* eslint-disable sort-keys */

import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

// The init() function returns a promise. We export it so that
// Our application's entry point can wait for it to resolve.
export const i18nPromise = i18next
  .use(Backend)
  .use(LanguageDetector)
  .init({
    fallbackLng: "fr",
    load: "languageOnly",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
    detection: {
      order: [
          "htmlTag",
          "querystring",
          "localStorage",
          "navigator"
      ],
  }
  });

export default i18next;
